var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/phone") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/phone",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.79467719,1.11125161 L1.45036405,2.45756458 C0.0141802168,3.89374841 -0.210434627,6.13446261 0.909625011,7.82932209 C4.87788365,13.8289151 10.1695675,19.1208603 16.1696368,23.0904492 C17.8624183,24.2095318 20.1104238,23.9844771 21.5429777,22.5506925 L22.8879451,21.2047252 C24.104311,19.9897053 24.104311,18.0174484 22.8871081,16.8029385 L20.4347349,14.3505646 L20.2914235,14.2154727 C19.0705322,13.134738 17.2018545,13.1797802 16.0320514,14.3508774 L15.731,14.651 L15.6772415,14.6065234 C13.6495457,12.8901853 11.677543,10.9459689 9.91680529,8.92958876 L9.35,8.268 L9.65138881,7.9682813 C10.8660499,6.75227436 10.8660499,4.78122564 9.65204821,3.56587806 L7.1977349,1.11156458 C5.98236763,-0.103802697 4.01107707,-0.103802697 2.79467719,1.11125161 Z M6.06636405,2.24293542 L8.52036405,4.69693542 C9.11004905,5.28727436 9.11004905,6.24622564 8.52005074,6.83687806 L7.70271014,7.6532187 C7.4116686,7.94390444 7.38850076,8.40792283 7.64913989,8.72615328 C9.88714663,11.4586742 12.5427374,14.1150514 15.2730334,16.3520672 C15.5909697,16.6125622 16.0545729,16.5897417 16.3453888,16.2992813 L17.1633888,15.4822813 C17.7554523,14.8895636 18.7129544,14.8895636 19.3024257,15.4809955 L21.7563641,17.9349354 C22.347788,18.5250516 22.347788,19.4827947 21.7566772,20.0732516 L20.4111539,21.4197748 C19.5166815,22.3150156 18.1108716,22.4557555 17.0522302,21.7558974 C11.2317705,17.9051363 6.09371213,12.7668242 2.24430067,6.94691584 C1.54328203,5.88614356 1.68352071,4.48714961 2.58215533,3.58851468 L3.92615533,2.24251468 C4.51702188,1.6523027 5.47573132,1.6523027 6.06636405,2.24293542 Z",
    id: "Stroke-1",
    fill: "currentColor",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e53c9f23.svg";
export { ForwardRef as ReactComponent };